export const apiUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return "";
  }
  if (process.env.NODE_ENV === "production") {
    return process.env.REACT_APP_API_URL;
  }
};
